import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function MarketingAutomation() {
  return (
    <>
<Features docname="Marketing Automation"/>
<Advantages docname="Marketing Automation"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default MarketingAutomation;
